export const getSortOptions = (isOriginDeadHead: boolean, isDestinationDeadHead: boolean) => {
    return [
      { value: 'pickUpStartDate', name: 'Pick-Up Date' },
      { value: 'total_distance', name: 'Distance' },
      { value: "price", name: "Price" },
      ...(isOriginDeadHead !== undefined && isOriginDeadHead ? [ { value: "originDeadHead", name: "Origin Deadhead" }]:[]),
      ...(isDestinationDeadHead !== undefined && isDestinationDeadHead ? [{value: "destinationDeadHead", name: "Destination Deadhead" }]:[])
      ];
  }